import { object, number, string, boolean, array } from 'zod';
import { validateCpf } from '~/utils/validCpf';

const uploadedFiles = object({
  id: number(),
  filename: string(),
  size: string().optional(),
  examType: number().optional(),
  examTypeName: string().optional(),
  mimetype: string().optional(),
  created: string().optional(),
  loading: boolean().optional(),
});

export const requestSchema = object({
  profession: string().optional(),
  profissional: string().optional(),
  specialtySelected: boolean().optional(),
  professionalSelected: boolean().optional(),
  phone: string().optional(),
  state: string().nonempty({ message: 'Campo obrigatório' }),
  county: string()
    .nonempty({ message: 'Campo obrigatório' })
    .refine(value => !value.includes('Selecione'), {
      message: 'Selecione seu município',
    }),
  healthUnit: string().nonempty({ message: 'Campo obrigatório' }),
  fullName: string()
    .nonempty({ message: 'Digite ou selecione um paciente' })
    .min(4, { message: 'Digite no mínimo 4 caracteres' }),
  sex: string().nonempty({ message: 'Campo obrigatório' }),
  birthDate: string().nonempty({ message: 'Campo obrigatório' }),
  regType: string().nonempty({ message: 'Campo obrigatório' }),
  regValue: string().nonempty({ message: 'Campo obrigatório' }),
  motherName: string().nonempty({ message: 'Campo obrigatório' }).optional(),
  isDisabled: boolean().optional(),
  consultant: number().optional(),
  patientDescription: string().optional(),
  orgUnit: number().optional(),
  specialty: string().optional(),
  description: string().optional(),
  responsePriority: string().optional(),
  files: array(uploadedFiles).optional(),
}).refine(
  data => {
    switch (data.regType) {
      case 'CPF':
        return validateCpf(data.regValue);
      case 'DNV':
        return /^\d{11}$/.test(data?.regValue);
      case 'CNS':
        return /^\d{15}$/.test(data?.regValue);
      case 'RG':
        return true;
      default:
        return false;
    }
  },
  {
    message: 'Documento inválido',
    path: ['regValue'],
  },
);

export const fileSchema = object({
  ...requestSchema.shape,
  files: array(uploadedFiles).optional().nullable(),
});
